import { useAppUser } from '~/components/molecules/appuser/appuser-context';
import { CrewMemberAssignment } from '@bechtel/types';

export function useWorkPackageOwner(assignedCrewMembers?: CrewMemberAssignment[], crewMemberId?: string): boolean {
  const { user } = useAppUser();
  const idToCheck = crewMemberId || (user && user.id);
  if (assignedCrewMembers && assignedCrewMembers.length && idToCheck)
    return assignedCrewMembers.some((assignedCrewMember) => assignedCrewMember?.crewMember?.id === idToCheck);
  return false;
}
